/**

 * Arranque: auth inicializada en index.tsx (bootstrap Keycloak antes del render).

 */

import { CUSTOMERS_PATH } from '@constants/paths.constant';

import routesData from '@constants/routes.constant';

import SightLoading from '@features/common/Loading/SightLoading';

import LoginPage from '@features/auth/LoginPage';

import { MainContainer } from '@features/main';

import { useAuthBootstrap } from '@hooks/auth.hook';

import useAuthStore from '@stores/auth.store';

import { useEffect } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

const App: React.FC = () => {
	const { initializeFirebaseAfterAuth } = useAuthBootstrap();

	const loading = useAuthStore((s) => s.loading);

	const token = useAuthStore((s) => s.token);

	const user = useAuthStore((s) => s.user);

	const isAuthenticated = token != null && user != null;

	useEffect(() => {
		void initializeFirebaseAfterAuth();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token, user]);

	if (loading) {
		return <SightLoading show />;
	}

	if (!isAuthenticated) {
		return <LoginPage />;
	}

	return (
		<Routes>
			<Route path="/" element={<Navigate replace to={CUSTOMERS_PATH} />} />

			<Route path="/admin" element={<Navigate replace to={CUSTOMERS_PATH} />} />

			{routesData.map((route, i) => {
				return (route.requireLogged === true && isAuthenticated) || !route.requireLogged ? (
					<Route
						element={<MainContainer Component={route.Component} id={route.id} />}
						key={`route_${i}`}
						path={route.url}
					/>
				) : null;
			})}
		</Routes>
	);
};

export default App;
